import Api from '../../../../Api';
import { IQuickNotation } from '../Interfaces/IQuickNotation';

export const NotationWidgetService = {
  CreateQuickNotationWidget: async (
    request: IQuickNotation,
  ): Promise<IQuickNotation> => {
    const response = await Api.post(`management/quicknotationwidget`, request);
    return response.data;
  },
  GetQuickNotationWidget: async (): Promise<IQuickNotation> => {
    const response = await Api.get(`management/quicknotationwidget`);
    return response.data;
  },
  GetQuickNotationWidgetAllowAnonymous: async (): Promise<IQuickNotation> => {
    const response = await Api.get(`widget/quicknotationwidget`);
    return response.data;
  },
  UpdateQuickNotation: async (
    request: IQuickNotation,
  ): Promise<IQuickNotation> => {
    const response = Api.put(`management/quicknotationwidget`, request);
    return response.data;
  },
};
